import { ThemeProvider, createTheme } from "@mui/material";
import { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from "react-redux";
import MainPage from '../Views/Pages/Main';
import Stake from "../Views/Pages/Staking";
import {BrowserRouter as Router,Route,Routes,Link} from "react-router-dom";

const getActiveTheme = (themeMode) => {
  console.log('themeMode: ', themeMode)
  return createTheme({
    pageColor: '#000',

    bgPrimary: '#161616',
    bgSecondary: 'red',

    textPrimary: '#ffffff',
    textSecondary: 'black',
    textTertiary: '#1765FF',

    switchColor: '#b1b1b1',
  })
}
const ThemeContainer = () => {
  const currentTheme = useSelector((state) => state.LDTheme.value);
  const [activeTheme, setActiveTheme] = useState(getActiveTheme(currentTheme));

  useEffect(()=>{    
    setActiveTheme(getActiveTheme(currentTheme))
  },[currentTheme]);
  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route exact  path="/" element={<MainPage />} />
          <Route path="/" element={<MainPage />} />
          <Route path="/stake" element={<Stake />} />
        </Routes>
      </Router>
      {/* <MainPage toggleTheme='' /> */}
      {/* <Stake /> */}
    </ThemeProvider>
  );
}

export default ThemeContainer;